<!--
 * @Description: 
 * @Author: Ingyi
 * @Date: 2021-09-02 15:31:05
 * @LastEditors: Ingyi
 * @LastEditTime: 2021-09-02 15:33:13
-->
<template>
  <div>
    <div class="search-box">
      <div style="margin: 0px 0 20px 10px; padding-top: 20px">
        <span class="title" @click="$router.push('/')">首页</span> >
        <span class="title">公共服务</span> > <span class="title">IP问答</span>
      </div>

      <div class="help-page">
        <div>
          <a-menu style="width: 256px" mode="inline" @click="handleClick">
            <!-- <a-sub-menu key="sub1" @titleClick="titleClick">
          <span slot="title"><a-icon type="mail" /><span>新手入门</span></span>
        </a-sub-menu> -->

            <a-sub-menu
              v-for="(item, index) in list"
              :key="`${item.id}-${index}`"
              @titleClick="titleClick"
            >
              <span slot="title"
                ><a-icon type="mail" /><span>{{ item.title }}</span></span
              >
              <a-menu-item-group key="g1" v-if="item.chidren.length > 0">
                <a-menu-item
                  :key="`${data.id}-${index}`"
                  v-for="(data, index) in item.chidren"
                >
                  {{ data.title }}</a-menu-item
                >
              </a-menu-item-group>
            </a-sub-menu>

            <!-- <a-sub-menu key="sub2" @titleClick="titleClick">
          <span slot="title"><a-icon type="question-circle" /><span>平台规则</span></span>
        
        </a-sub-menu>-->
          </a-menu>
        </div>
        <div class="right-box">
          <h2>{{ data.question }}</h2>
          <p>
            {{ data.anwer }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '../util/request'
export default {
  name: 'help',
  data() {
    return {
      data: {},
      list: [],
      openKeys: ['sub1', 'sub2'],
      selectedkey: null,
    }
  },
  mounted() {
    this.queryList()
  },
  methods: {
    queryList() {
      request({
        url: '/api/client/common/question/list',
        method: 'get',
      }).then((res) => {
        if (res.code == '200') {
          this.list = res.data
          let id = this.list[1].chidren[0].id
          this.queryDetail(id)
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    queryDetail(id) {
      request({
        url: '/api/client/common/question/' + id,
        method: 'get',
      }).then((res) => {
        if (res.code == '200') {
          this.data = res.data
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    titleClick(param) {
      console.log('titleClick', param)
    },
    handleClick(param) {
      // console.log('handleClick', param)
      this.selectedkey = this.extractNumber(param.key)
      this.queryDetail(this.selectedkey)
    },
    extractNumber(string) {
      const regex = /(\d+)-/ // 正则表达式匹配数字后面的横线
      const result = regex.exec(string)
      if (result && result.length > 1) {
        return result[1] // 返回匹配结果中第一个括号内的数字
      }
      return ''
    },
  },
}
</script>

<style lang="less">
.shen-title {
  height: 44px;
  display: flex;
  background: #fff;
  align-items: center;
  .title {
    font-size: 14px;
    cursor: pointer;
  }
  span {
    padding: 10px;
  }
  .active {
    color: #1890ff;
  }
}
.help-page {
  width: 1280px;
  background: #fff;
  margin: 20px auto;
  display: flex;
  padding: 20px;
  .right-box {
    flex: 1;
    margin: 0 20px;
    border: 1px solid #ccc;
    border-radius: 5px;
    padding: 20px;
    h2 {
      border-bottom: 1px solid #ccc;
      padding: 10px;
    }
  }
}
</style>
